import angular from 'angular';
import template from './transfer_table.html.slim';
import controller from './transfer_table_controller';

const directive = {
  restrict: 'E',
  controller,
  controllerAs: 'ctrl',
  bindToController: true,
  replace: true,
  templateUrl: template,
  scope: {
    accounts: '=',
    transfers: '=',
    editTransfer: '&',
    cancelTransfer: '&',
    restoreTransfer: '&',
    loading: '=',
  },
  link($scope, $el, $attrs) {
    return $attrs.$observe('category', (category) => { $scope.category = category; });
  },
};

angular.module('wbComponents').directive('wbTransferTable', () => directive);
